export const ALL_SKILLS = [
  // Woodworking
  "CNC", "Hand-carved", "Dovetail", "Mortise & Tenon", "Woodturning", "Scroll Saw",
  "Pyrography", "Epoxy Resin", "Steam Bending", "Inlay", "Marquetry", "Hand-planed",
  "Bandsaw Box", "Segmented", "Chip Carving", "Relief Carving", "Whittling",
  "Spalting", "Live-edge", "Reclaimed Wood", "Bent Lamination", "Doweling",
  "Biscuit Joinery", "Finger Joints", "Japanese Joinery", "Kumiko",
  // Metalworking
  "Welding", "Forging", "Blacksmithing", "Metal Inlay", "Casting", "Sheet Metal",
  "Plasma Cutting", "Patina", "Copper Work", "Brass Work",
  // Fabric & Stitching
  "Leather Work", "Upholstery", "Stitching", "Weaving", "Macrame", "Embroidery",
  "Canvas Work", "Saddle Making",
  // Finishing
  "French Polish", "Lacquer", "Oil Finish", "Wax Finish", "Staining",
  "Milk Paint", "Gilding", "Distressing", "Shou Sugi Ban",
  // Technology
  "Laser Engraving", "3D Printing", "CAD Design", "Digital Plans",
  // Other
  "Glass Work", "Stained Glass", "Ceramics", "Stone Carving", "Bone Carving",
  "Basket Weaving", "Caning", "Veneer", "Parquetry"
];

// Keyword-to-skill mapping for auto-suggestions
export const SKILL_KEYWORDS = {
  "cnc": "CNC",
  "router": "CNC",
  "carve": "Hand-carved",
  "carved": "Hand-carved",
  "carving": "Hand-carved",
  "dovetail": "Dovetail",
  "mortise": "Mortise & Tenon",
  "tenon": "Mortise & Tenon",
  "lathe": "Woodturning",
  "turning": "Woodturning",
  "turned": "Woodturning",
  "scroll": "Scroll Saw",
  "pyrography": "Pyrography",
  "woodburn": "Pyrography",
  "burn": "Pyrography",
  "epoxy": "Epoxy Resin",
  "resin": "Epoxy Resin",
  "river table": "Epoxy Resin",
  "steam": "Steam Bending",
  "bent": "Steam Bending",
  "bending": "Steam Bending",
  "inlay": "Inlay",
  "marquetry": "Marquetry",
  "hand-planed": "Hand-planed",
  "hand plane": "Hand-planed",
  "bandsaw box": "Bandsaw Box",
  "segmented": "Segmented",
  "chip carv": "Chip Carving",
  "relief": "Relief Carving",
  "whittle": "Whittling",
  "spalt": "Spalting",
  "live-edge": "Live-edge",
  "live edge": "Live-edge",
  "reclaimed": "Reclaimed Wood",
  "pallet": "Reclaimed Wood",
  "barn wood": "Reclaimed Wood",
  "lamination": "Bent Lamination",
  "dowel": "Doweling",
  "biscuit": "Biscuit Joinery",
  "finger joint": "Finger Joints",
  "box joint": "Finger Joints",
  "japanese": "Japanese Joinery",
  "kumiko": "Kumiko",
  "weld": "Welding",
  "welded": "Welding",
  "forge": "Forging",
  "forged": "Forging",
  "blacksmith": "Blacksmithing",
  "anvil": "Blacksmithing",
  "cast": "Casting",
  "plasma": "Plasma Cutting",
  "patina": "Patina",
  "copper": "Copper Work",
  "brass": "Brass Work",
  "leather": "Leather Work",
  "upholster": "Upholstery",
  "stitch": "Stitching",
  "sew": "Stitching",
  "weav": "Weaving",
  "macrame": "Macrame",
  "embroider": "Embroidery",
  "canvas": "Canvas Work",
  "saddle": "Saddle Making",
  "french polish": "French Polish",
  "shellac": "French Polish",
  "lacquer": "Lacquer",
  "oil finish": "Oil Finish",
  "danish oil": "Oil Finish",
  "tung oil": "Oil Finish",
  "wax": "Wax Finish",
  "stain": "Staining",
  "milk paint": "Milk Paint",
  "gild": "Gilding",
  "gold leaf": "Gilding",
  "distress": "Distressing",
  "shou sugi": "Shou Sugi Ban",
  "charred": "Shou Sugi Ban",
  "laser": "Laser Engraving",
  "engrav": "Laser Engraving",
  "3d print": "3D Printing",
  "cad": "CAD Design",
  "sketchup": "CAD Design",
  "fusion 360": "CAD Design",
  "glass": "Glass Work",
  "stained glass": "Stained Glass",
  "ceramic": "Ceramics",
  "pottery": "Ceramics",
  "stone": "Stone Carving",
  "bone": "Bone Carving",
  "basket": "Basket Weaving",
  "caning": "Caning",
  "veneer": "Veneer",
  "parquetry": "Parquetry",
};

export function suggestSkills(text) {
  if (!text) return [];
  const lower = text.toLowerCase();
  const suggestions = new Set();
  Object.entries(SKILL_KEYWORDS).forEach(([keyword, skill]) => {
    if (lower.includes(keyword)) suggestions.add(skill);
  });
  return [...suggestions];
}
